import { useLocation } from 'react-router-dom';

const useDashboardCheck = () => {
    const location = useLocation();
    const dashboardRoutes = ['/user-dashboard', '/vendor-dashboard', '/admin-dashboard', '/co-ordinator-dashboard'];
    return dashboardRoutes.some(route => location.pathname.startsWith(route));
};

export default useDashboardCheck;
